import type { SocialsData } from '../types';

export const DEFAULT_SOCIALS_ORDER = [
  'twitter',
  'linkedin',
  'facebook',
  'instagram',
  'tiktok',
  'youtube',
  'discord',
  'threads',
  'bluesky',
  'rss',
] as const;

export type SocialsPlatformKey = (typeof DEFAULT_SOCIALS_ORDER)[number];

const KNOWN_KEYS: ReadonlySet<string> = new Set(DEFAULT_SOCIALS_ORDER);

export const isSocialsPlatformKey = (value: string): value is SocialsPlatformKey => KNOWN_KEYS.has(value);

export const validSocialsOrder = (order: unknown): SocialsPlatformKey[] | null => {
  if (!Array.isArray(order)) return null;

  const seen = new Set<string>();
  const result: SocialsPlatformKey[] = [];

  for (const key of order) {
    if (typeof key !== 'string' || !isSocialsPlatformKey(key) || seen.has(key)) continue;
    seen.add(key);
    result.push(key);
  }

  return result.length > 0 ? result : null;
};

export const socialUrl = (data: SocialsData | undefined, key: SocialsPlatformKey): string | undefined =>
  data?.[`${key}_url`];
